<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="big_tit">
        {{ $t('income.basicin') }}
      </div>
    </div>
	
    <!-- 	<div class="main_title">
	    <div class="ft28 title c-white">{{$t('trading.balance')}}</div>
	    <div class="c-white ft48 font-bold">
	        {{acc?acc.money:'0.00'}}
	        <span class="ft28 ml20">{{utils_moneyMark()}}</span>
	    </div>
	    <div>
			<img src="../images/trading/homeicon.png" >
	    </div>
	</div> -->
    <div class="work_content">
      <div
        v-if="vip"
        class="main_work_title"
      >
        <div class="card-name">
          {{ $t('vip2.level') }}：{{ vip.name }}
        </div>
        <div class="h2">
          {{ $t('trading.everyday') }}：<em>{{ vip.rate }} % </em>
        </div>
        <span><img
          src="../images/trading/top.png"
          draggable="true"
        ></span>
        <div class="title">
          {{ $t('trading.working') }}
        </div>
        <div class="flex-wrap flex-center">
          <div class="left">
            <b>{{ $t('income.lingt') }}</b>
            <em>{{ $t('income.lingti') }}</em>
            <!-- <em>最低收益需至少存款<i class="text-primary">5.00 USDT</i></em> -->
          </div>
          <div class="right">
            <div
              class="basic_btn btn  "
              @click="$router.push('/invest2')"
            >
              {{ $t('income.paynow') }}
            </div>
          </div>
        </div>
      </div>
      <div class="main_work">
        <div class="title flex alcenter flex-between">
          <div class="fl">
            <div class="ft36 c_191919 font-bold">
              {{ $t('trading.profit') }}
            </div>
          </div>
          <router-link to="/moneybag">
            <div class="flex-center view-all">
              <div>{{ $t('trading.all') }}</div>
              <span>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAhCAMAAAAMPGBYAAAAAXNSR0IArs4c6QAAAXpQTFRFAAAAAAAAAAD/////gICAqqqqgIC/mZmZqqqqkpKSn5+fv7+/jo6qqqqqmZmZoqKikpKkmZmZmZmqj4+fn5+flpalnJyqmZmmm5uml5ehkpKklZWnmZmhl5enm5uilpalmZmgmZmomJillJShnJyimJiompqklpaklZWjl5ekmZmhmJigmJikmJijl5eilpajlpajmpqjlpailpail5ejlpakl5eil5eimJilmZmjlpakmJijlZWjmJijmJiimJiil5ejlZWhlpakmJiilpakl5eil5eil5eilpajlpajl5eimJijl5ejlpajlpail5ejlpajl5eilpajl5ejlpahlpajlpajlpailpailpail5eilpailpajl5eilpajlpail5eilpailpahlpahlpajl5ejlpailpajlpajl5ehlpajlpailpajlpailpajlpailpajlpahlpail5eilpailpailpajlpail5eil5ejlpahlpailpailpaiGABniQAAAH10Uk5TAAEBAQIDBAUGBwgICQkKCw4PDxAQERIUFxscHR4gISIjIyUmLC81ODo7PD5DRUdLUFNVWltcXWBjZm1vdHd8fn+AgYGDhIeJi42ao6msra6xs7S1trbIys7R0tTV1djc3N3f4uXo6e7w8PHy8/T09fb4+Pn6+/v8/Pz9/f5vis/sAAABB0lEQVQYGV3BZSNsUQCG0ZdjdDOakVdd3d3tqpFXd42Og/H8dx/33tZSXNN8vn5p3CFcJdcC+KvFchRufcNGqhx/NoFwhWwxNdsQXSmTo+g/fIc9OWq3gfUS2WLr9oDlkBzl+/C+kiJH3S4QLpDN+3sELIVk86oP4HUpW476Q2AtUzav5QT4Vyqb13AML4v5cvQD0U5ZUnsfIDKWLiN5IALR0VxZeq4gOpgoI7EtAnfjSTKS++7hayooI677Aj6GMmQEmm/hcSIgI6nrBj6ngzICHWfgD2fJiGm8hrdRWRJaL+F1NkdGoP0U/MmgLA3n4I/Ey7bo8zSXKUfp2vNMnlyxlR1pcv0AgJdH6WBftxEAAAAASUVORK5CYII="
                  draggable="true"
                >
              </span>
            </div>
          </router-link>
        </div>
        <div
          v-if="list&&list.length>0"
          class="list"
        >
          <div
            v-for="(item,index) in list"
            class="lidiv flex alcenter flex-between"
          >
            <div class="icon flex alcenter">
              <span>
                <div style="background-image: url('../images/trading/trading.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;" />
                <img
                  src="../images/trading/trading.png"
                  draggable="true"
                ></span>
              <div class="grow">
                <div class="price">
                  {{ item.money }}
                  <div>{{ utils_moneyMark() }}</div>
                </div>
                <div class="des">
                  <!-- {{$t('trading.revenue')}} -->
                  {{ dateFormat('yyyy-MM-dd H:m:s', item.t) }}
                </div>
              </div>
            </div>
            <div
              v-if="item.stat=='99'"
              class="basic_btn btn flex-wrap font-bold"
              @click="receive(item.id)"
            >
              {{ $t('trading.receive') }}
            </div>
            <div
              v-else
              class="gray_btn btn flex-wrap font-bold "
            >
              {{ $t('trading.receive') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field} from 'vant';

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
  name: "Trading",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      tabs: [
        {name:0,title:this.$t('item.all')}
      ],
      active: 0,
	  acc:null,
	  vip:null,
      list: []
    }
  },
  created() {
    this.$parent.footer('trading');
  },
  mounted() {
    this.accinfo();
    this.start();
  },
  methods: {
	dateFormat(fmt, time) {
		var date = new Date(time*1000);
		var year = date.getFullYear();
		var month = ("0" + (date.getMonth() + 1)).slice(-2);
		var day = ("0" + date.getDate()).slice(-2);
		var hours = ("0" + date.getHours()).slice(-2);
		var minutes = ("0" + date.getMinutes()).slice(-2);
		var seconds = ("0" + date.getSeconds()).slice(-2);
		
		var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		return formattedDate
	},
	receive(id){
	  Fetch('/user/trading_receive', {
        id: id
      }).then(r => {
		  this.$toast({
		      background: "#07c160",
		      message: this.$t('trading.receivesuc'),
		  });
		  this.list = r.data.list;
	  })
	},
	start() {
		Fetch('/user/item_trading').then(r => {
		  this.list = r.data.list;
		})
	},
	accinfo() {
		Fetch('/user/basicinfo').then((r) => {
			this.acc = r.data;
			this.vip = r.data.vip;
		});
	}
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}
.btn{
    width: 62px;
    height: 24px;
    border-radius: 5px;
    font-size: 9px;
    color: #fff;
    margin-right: 8px;
    line-height: 24px;
}
.red_top_bg {

}

.basic_wrap {
  position: relative;
}

.item_wrap {
  width: 100%;
  padding: 44px 0 0 0;

  .tabs {
    position: fixed;
    z-index: 100;
    width: 100%;

    max-width: 750px;
  }
}

.item_margin {
  margin-top: 54px !important;
}
.work_content{
    padding-bottom: 26px;
    overflow: hidden;
	.main_work_title{
	    margin: 10px;
		padding: 20px;
		border-radius: 10px;
		background: #FFF;
	    text-align: center;
		position: relative;
		.h2{
			font-size: 14px;
			margin-top: 20px;
			em{
				color: #ee264d;;
				font-size: 16px;
			}
		}
		span{
		    display: block;
		    margin: 0 auto 18px;
			img{
				width: 100%;
			}
		}
		.title{
		    text-align: center;
		    font-size: 20px;
		    color: #000;
		    font-weight: 700;
		}
	}
	.main_work{
	    overflow: hidden;
	    padding: 21px 17px;
	    box-sizing: border-box;
		border-radius: 10px;
		margin: 10px;
		background: #FFF;
		.title{
		    margin-bottom: 20px;
		    box-sizing: border-box;
		}
		.view-all{
		    color: #9999a5;
		    font-size: 14px;
			span{
			    width: 6px;
			    height: 11px;
			    margin-left: 7px;
				img{
					width: 6px;
					height: 11px;
				}
			}
		}
		.list{
		    margin-top: 10px;
			.lidiv{
			    height: 71px;
			    position: relative;
			    margin-bottom: 15px;
			    border-radius: 15px;
			    box-sizing: border-box;
				.icon {
					span:nth-child(1){
					    width: 50px;
					    height: 55px;
						img{
							width: 55px;
							height: 55px;
						}
					}
					.grow{
					    margin-left: 15px;
						.price{
						    font-size: 19px;
						    color: #48a093;
						    font-weight: 700;
						    display: flex;
						    align-items: flex-end;
							div{
							    font-size: 11px;
							    color: #2a2a2a;
							    margin-left: 5px;
							    margin-bottom: 2px;
							}
						}
						.des{
						    font-size: 10px;
						    color: #b4b6bd;
						    margin-top: 10px;
						    line-height: 15px;
						}
					}
				}
				.btn{
				    width: 65px;
				    height: 24px;
				    border-radius: 5px;
				    font-size: 9px;
				    color: #fff;
					margin-right: 8px;
					line-height: 24px;
				}
				.btn.disabled{
				    opacity: .65;
				}
			}
			.lidiv:nth-child(odd) {
			    background-color: #f8fdfb;
			}
			
		}
		
	}
}
.alcenter {
    align-items: center;
}
.flex {
    display: flex;
}
.font-bold {
    font-weight: 700;
}
.ft36 {
    font-size: 18px;
}
.c_191919 {
    color: #191919;
}
.flex-between {
    display: flex;
    justify-content: space-between!important;
}
.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.main_title{
    position: relative;
    width: 100%;
    height: 203px;
    background-image: url(../images/trading/homeicon12.png);
    background-size: 100% 100%;
    padding: 62px 0 0 48px;
    box-sizing: border-box;
	.title{
	    color: #fff;
	    margin-bottom: 15px;
	}
	div:nth-child(3){
	    position: absolute;
	    top: 41px;
	    right: 12px;
	    width: 142px;
	    height: 126px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	
}
.ft28 {
	font-size: 14px;
}
.font-bold {
    font-weight: 700;
}
.ft48 {
    font-size: 24px;
}
.ml20 {
    margin-left: 10px;
}
.c-white {
    color: #fff;
}
.flex-wrap.flex-center{
    justify-content: space-between;
	margin-top: 20px;
	.left b {
        display: block;
        font-size: 16px;
        font-weight: 400;
    	text-align: left;
		margin-bottom: 10px;
    }
    .left em {
        display: block;
        margin-top: 5px;
        font-size: 12px;
        font-style: normal;
    	text-align: left;
        color: #ababab;
    }
}
.card-name {
	position: absolute;
	top: 0;
	left: 0;
	padding: 5px 15px;
	background-color: #ee264d;;
	border-radius: 10px 0 5px 0;
	color: #fff;
	font-size: 14px;
}

</style>
